import type stockOutId from "./id";

const stockOutEn: typeof stockOutId = {
	stock_out: {
		title: "Stock Out",
		subtitle: "Summary of stock out records",
	table: {
		title: "Stock Out Data",
		columns: {
			date: "Date",
			ref_id: "Ref ID",
			store: "Store",
			notes: "Notes",
			created_by: "Created By",
			status: "Status",
		},
	},
		empty_state: {
			title: {
				has_filter: "No data matches",
				no_filter: "No stock out data",
			},
			description: {
				has_filter:
					"No data found with the selected filter. Please change your filter.",
				no_filter: "Please add a new stock out record.",
			},
		},
		forms: {
			edit: {
				title: "Edit Stock Out",
				info: "Stock out information",
				fields: {
					ref_id: {
						label: "RefId",
						placeholder: "refId",
					},
					store: {
						label: "Store",
						placeholder: "Select Store",
					},
					notes: {
						label: "Notes",
						placeholder: "notes",
					},
					status: {
						label: "Status",
						placeholder: "Select status",
					},
				},
				options: {
					active: "Active",
					inactive: "Inactive",
				},
			},
			add: {
				button: "Add Stock Out",
				title: "Add Stock Out",
				description: "Add a new stock out record",
				fields: {
					store: {
						label: "Store",
						placeholder: "Select Store",
					},
					notes: {
						label: "Notes",
						placeholder: "Enter Notes",
					},
					processed_at: {
						label: "Processing Date",
					},
					product_detail: {
						title: "Product Detail",
						loading: "Loading products...",
						product: {
							label: "Product",
							placeholder: "Select Product",
							search_product: "Search for Product...",
							not_found_product: "No product found",
						},
						qty: {
							label: "QTY",
							placeholder: "0",
						},
						unit: {
							label: "Unit",
							placeholder: "Pcs",
						},
						action: {
							label: "Action",
						},
					},
				},
			},
		},
		actions: {
			save: "Save",
			saving: "Saving...",
			cancel: "Cancel",
			save_changes: "Save Changes",
			add_products: {
				already_added: "This Product already added.",
				button: "Add more Product",
			},
		},
		status: {
			processed: "On Process",
			inactive: "Inactive",
		},
	},
};

export default stockOutEn;
